import React from "react";
import Modal from "../../../../components/common/Modal";

interface DeleteModalProps {
  isOpen: boolean;
  title: string;
  deleteInfo: string;
  deleteButtonInfo?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const MODAL_STYLES = `
  #modal-manual-trig .modal-container {
    max-width: 45% !important;
    width: 90% !important;
    top: 20% !important;
  }
`;

const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, title, deleteInfo, deleteButtonInfo = 'Delete',  onCancel, onConfirm }) => (
  <div>
    <Modal
      isOpen={isOpen}
      title={title}
      clearBtn="Cancel"
      submitBtn={deleteButtonInfo}
      onSecondary={onCancel}
      onPrimary={onConfirm}
      onClose={onCancel}
    >
      <div className="flex items-center gap-3">
        <img
          src="/assets/images/alertSolid.svg"
          alt="alert-icon"
          className="w-10 h-10 shrink-0"
        />
        <p className="p3 -book mb-4!">{deleteInfo}</p>
      </div>
      <style>{MODAL_STYLES}</style>
    </Modal>
  </div>
);

export default DeleteModal;
